import { request } from '../request'

// 结果插件列表
export interface GetResultPluginList {
  task_id: string | null
  result_id: string | undefined
  keyword: string
  risk_level: number[]
  attack_type: string[]
  supported_platforms: number[] //1 windows 3.linux
  att_ck: string[]
  // 安全设备
  device_import_log_record_id: string[]
  /**依赖环境 */
  depend_envs: string[]
  alert_log: number
  /**拦截状态 */
  status: number
  page: number
  limit: number
  tag_ids: string[]
}
export const getResultPluginList = (data: GetResultPluginList) =>
  request('/portal/verify/endpointSecurity/resultPluginList', {
    method: 'post',
    data,
  })

// 插件详情
export interface GetResultPluginDetail {
  id: string
  result_id: string
}
export const getResultPluginDetail = (data: GetResultPluginDetail) =>
  request('/portal/verify/endpointSecurity/resultPluginDetail', {
    params: {
      ...data,
    },
  })

//  任务信息 任务进度
export interface GetResultInfo {
  result_id: string | null | undefined
  task_id: string | null
}
export const getResultInfo = (data: GetResultInfo) =>
  request('/portal/verify/endpointSecurity/resultInfo', {
    params: {
      ...data,
    },
  })

//  任务信息 任务详情的att&ck列表
export interface GetDetailAttCkList {
  result_id: string
  task_id: string | null
}
export const getDetailAttCkList = (data: GetDetailAttCkList) =>
  request(`/portal/v1/endpoint_security/result/${data.result_id}/attck_list`, {
    params: {
      ...data,
    },
  })

//  任务信息 任务详情环形图
export interface GetResultRingPattern {
  result_id: string
}
export const getResultRingPattern = (data: GetResultRingPattern) =>
  request('/portal/verify/endpointSecurity/resultRingPattern', {
    params: {
      ...data,
    },
  })

//  任务信息 任务详情攻击防护排名
export interface GetResultDefenseRankings {
  resultId: string
}
export const getResultDefenseRankings = (data: GetResultDefenseRankings) =>
  request('/portal/v1/endpoint_security/attack_protection_ranking', {
    params: {
      ...data,
    },
  })

//  任务信息 任务详情危险等级分布
export interface GetResultRiskLevel {
  resultId: string
}
export const getResultRiskLevel = (data: GetResultRiskLevel) =>
  request('/portal/v1/endpoint_security/risk_level_distribution', {
    params: {
      ...data,
    },
  })

//获取攻击类型列表
export const getAttackType = (data: GetResultRiskLevel) =>
  request(`/portal/verify/endpoint_security/results/${data.resultId}/attack_type`)

//任务详情获取依赖环境下拉列表
export const getResultDependEnvsOption = (data: GetResultRiskLevel) =>
  request('/portal/verify/endpointSecurity/resultDependEnvsOption', { params: data })

//获取详情设备下拉列表
export const getResultDeviceOption = (data: GetResultRiskLevel) =>
  request('/portal/verify/endpointSecurity/resultDeviceOption', { params: data })
//获取模板拦截成功率排名
export const getResultTemplateRankings = (data: GetResultRiskLevel) =>
  request('/portal/verify/endpointSecurity/resultTemplateRankings', { params: data })

// 树结构标签选项
export const getTagTreeOptions = data =>
  request('/portal/v1/endpoint_security/bind_tag_snapshot_list', { params: data })

// 获取离线日志导入信息
export const getOfflineLogImportInfo = id =>
  request(`/portal/v1/endpoint_security/results/${id}/get_log_device_import_records`)

// 删除日志设备导入记录
export const deleteOfflineLogImportRecord = data =>
  request(
    `/portal/v1/endpoint_security/results/${data.resultId}/log_device_import_record/${data.id}`,
    {
      method: 'delete',
      timeout: 60000,
    },
  )

// 更新资源拦截状态
export const updateResourceInterceptStatus = data =>
  request(`/portal/verify/endpointSecurity/result/resourceIntercept/${data.id}`, {
    method: 'PUT',
    data: data.list,
  })

// 获取执行失败用例列表
export const getSentFailedCaseList = id =>
  request(`/portal/v1/endpoint_security/result/${id}/sentFailedCaseList`)

// 未执行用例列表
export const getUnsentCaseList = id =>
  request(`/portal/v1/endpoint_security/result/${id}/unsentCaseList`)

// 取消验证用例列表
export const getCancelVerifyCaseList = id =>
  request(`/portal/v1/endpoint_security/result/${id}/cancelValidCaseList`)

// 验证结果分布
export const getVerifyResultDistribution = id =>
  request(`/portal/v1/endpoint_security/verify_result_distribution`, {
    params: {
      resultId: id,
    },
  })

// 用例等级分布
export const getCaseLevelDistribution = id =>
  request(`/portal/v1/endpoint_security/tasks/${id}/resource_level_distribution`)

// 模板防护失效率排名
export const getTemplateProtectionFailureRate = id =>
  request(`/portal/v1/endpoint_security/tasks/${id}/template_statistic`)

// 设备防护能力排名
export const getDeviceProtectionRanking = id =>
  request(`/portal/v1/endpoint_security/tasks/${id}/device_defence`)

// 获取模板名称列表
export const getTemplateNameList = id =>
  request(`/portal/v1/endpoint_security/tasks/${id}/template_list`)

// 获取任务详情用例列表筛选数据
export const getTaskDetailFilterData = id =>
  request(`/portal/v1/endpoint_security/tasks/${id}/filter_data`)
